export enum EDiseaseType {
    disease = 1,
    surgury = 2
}